export default __webpack_public_path__ + "static/media/down.6af91673.svg";